(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TransactionAsyncTaskDeleteController',TransactionAsyncTaskDeleteController);

    TransactionAsyncTaskDeleteController.$inject = ['$uibModalInstance', 'entity', 'TransactionAsyncTask'];

    function TransactionAsyncTaskDeleteController($uibModalInstance, entity, TransactionAsyncTask) {
        var vm = this;

        vm.transactionAsyncTask = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TransactionAsyncTask.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
